import { Navigate } from '@sorare/routing';
import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MARKET_SHOP_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const MobileInstantBuyPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET_SHOP_INSTANT_BUY, {
        sport: Sport.FOOTBALL,
      })}
    />
  );
};

export default MobileInstantBuyPage;
